export const getOrgRole = (user, organizationId) => {
  if (!user || !user.organizationRoles || !organizationId) return null;
  return (
    user.organizationRoles.find(
      (orgRole) => orgRole.organizationId === organizationId
    ) || null
  );
};

export const isOrgOwner = (user, organizationId) => {
  const orgRole = getOrgRole(user, organizationId);
  return !!orgRole && (orgRole.role === "OWNER" || orgRole.role === "EDITOR");
};

export const getDirectProjectRole = (user, projectId) => {
  if (!user || !user.projectRoles || projectId == null) return null;
  return user.projectRoles.find((role) => role.projectId === projectId) || null;
};

export const getInheritedProjectRole = (user, path = []) => {
  if (!user || !user.projectRoles || !path.length) return null;
  for (let i = path.length - 1; i >= 0; i--) {
    const role = getDirectProjectRole(user, path[i].id);
    if (role) return role;
  }
  return null;
};

export const getEffectiveProjectRole = (user, project) => {
  if (!project) return null;
  return (
    getDirectProjectRole(user, project.id) ||
    getInheritedProjectRole(user, project.path || [])
  );
};
